import React from 'react';
import { Search, LogOut, Bell, CircleHelp as HelpCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useGamification } from '../contexts/GamificationContext';
import { ChatBot } from './ChatBot';
import { ThemeSelector } from './ThemeSelector';
import toast from 'react-hot-toast';

export const Header: React.FC = () => {
  const { user, signOut } = useAuth();
  const { userStats } = useGamification();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('[HEADER] Logout error:', error);
      toast.error('Erro ao fazer logout');
      navigate('/login');
    }
  };

  return (
    <header className="h-16 bg-white/80 dark:bg-gray-900/80 backdrop-blur-md border-b border-outline-variant dark:border-gray-700 flex items-center justify-between px-gutter sticky top-0 z-40 transition-colors duration-300">
      <div className="flex-1 max-w-md">
        <div className="relative group">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-secondary dark:text-gray-400 w-5 h-5 group-focus-within:text-primary transition-colors" />
          <input
            type="text"
            placeholder="Pesquisar na intranet..."
            className="w-full bg-surface-container dark:bg-gray-800 border-none rounded-full pl-10 pr-4 py-2 text-sm text-on-surface dark:text-gray-200 focus:ring-2 focus:ring-primary/20 focus:bg-white dark:focus:bg-gray-700 outline-none transition-all placeholder:text-secondary/60 dark:placeholder:text-gray-500"
          />
        </div>
      </div>

      <div className="flex items-center gap-2">
        <ChatBot />

        <ThemeSelector />

        <button className="hover:bg-surface-container dark:hover:bg-gray-700 rounded-full p-2 transition-all group">
          <Bell className="w-5 h-5 text-secondary dark:text-gray-400 group-hover:text-primary transition-colors" />
        </button>

        <button className="hover:bg-surface-container dark:hover:bg-gray-700 rounded-full p-2 transition-all group">
          <HelpCircle className="w-5 h-5 text-secondary dark:text-gray-400 group-hover:text-primary transition-colors" />
        </button>

        <div className="h-6 w-px bg-outline-variant dark:bg-gray-700 mx-2" />

        <button
          onClick={() => navigate('/perfil')}
          className="flex items-center gap-3 hover:bg-surface-container dark:hover:bg-gray-700 rounded-lg px-3 py-1.5 transition-all"
          title="Ver perfil"
        >
          <div className="text-right hidden sm:block">
            <p className="text-sm font-semibold text-on-surface dark:text-gray-100 leading-tight">
              {user?.name || user?.nome || 'Usuario'}
            </p>
            <p className="text-label-md text-secondary dark:text-gray-400">
              Nivel {userStats?.level || 1} - {userStats?.totalPoints || 0} pts
            </p>
          </div>
          <img
            src={user?.picture || 'https://images.pexels.com/photos/771742/pexels-photo-771742.jpeg?w=150'}
            alt={user?.name || user?.nome || 'Usuario'}
            className="w-9 h-9 rounded-full object-cover border-2 border-primary-container/30 shadow-sm"
            referrerPolicy="no-referrer"
          />
        </button>

        <button
          onClick={handleLogout}
          className="hover:bg-error-container/20 rounded-full p-2 transition-all group"
          title="Sair"
        >
          <LogOut className="w-5 h-5 text-error" />
        </button>
      </div>
    </header>
  );
};
